import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AgencyNameOutput',
  props: {
    input: null,
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var name = computed(function () {
      var _props$input;
      return (_props$input = props.input) === null || _props$input === void 0 ? void 0 : _props$input.name;
    });
    var type = computed(function () {
      var _props$input2;
      return ((_props$input2 = props.input) === null || _props$input2 === void 0 || (_props$input2 = _props$input2.type) === null || _props$input2 === void 0 ? void 0 : _props$input2.label) || undefined;
    });
    var isEmpty = computed(function () {
      return !(name.value && type.value);
    });
    return {
      __sfc: true,
      props: props,
      name: name,
      type: type,
      isEmpty: isEmpty
    };
  }
});